import { render, staticRenderFns } from "./TotalizerBlock.vue?vue&type=template&id=d616530a&scoped=true"
import script from "./TotalizerBlock.vue?vue&type=script&lang=js"
export * from "./TotalizerBlock.vue?vue&type=script&lang=js"
import style0 from "./TotalizerBlock.vue?vue&type=style&index=0&id=d616530a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d616530a",
  null
  
)

export default component.exports